module.exports = __webpack_public_path__ + "media/images/steps/step_14-49b7846cedabd87d50008b603648b563.svg";